import Add from './components/Add';
export default (props) => {
  return <Add {...props} />;
};
